exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-mask{position:fixed;z-index:9999;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.5)}.modal-mask .modal{position:fixed;top:50%;left:50%;background:#fff;box-shadow:3px 3px 6px 3px rgba(0,0,0,.1);transform:all .3s;display:flex;flex-flow:column;color:#474747}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d2ff4aaa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/Modal.vue
// module id = 251
// module chunks = 0